export enum CryptoInvoiceQueryKeys {
	CryptoInvoices = 'crypto-invoices',
	CryptoInvoiceById = 'crypto-invoice-by-id',
	BillingDetails = 'billing-details',
	CheckOverdue = 'check-overdue-invoices',
}

export enum CryptoInvoiceMutationKeys {
	GeneratePayment = 'generate-payment',
	ConfirmTransaction = 'confirm-transaction',
	CreatePrepayment = 'create-prepayment-invoice',
}

export const CRYPTO_INVOICES_KEYS = {
	all: () => [CryptoInvoiceQueryKeys.CryptoInvoices],
	list: (filters: unknown) => [...CRYPTO_INVOICES_KEYS.all(), 'list', filters],
	detail: (id: string) => [CryptoInvoiceQueryKeys.CryptoInvoiceById, id],
	billingDetails: (billingMonth: string) => [
		CryptoInvoiceQueryKeys.BillingDetails,
		billingMonth,
	],
	checkOverdue: () => [CryptoInvoiceQueryKeys.CheckOverdue],
}
